const getters = {
    getLogin(state) {
        const { loggedIn } = state;
        return loggedIn;
    }
};
export default getters;
